var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"charcoal d-flex flex-column",attrs:{"flat":"","tile":""}},[_c('v-spacer'),_c('v-card-text',{class:_vm.textSizeSmall + ' silver--text'},[_vm._v(" Redirecting... ")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }